var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Beasts h-100"},[_c('ItemTable',{attrs:{"fields":_vm.fields,"league":this.$parent.league,"getHref":this.getHref,"category":"beast","smallScreen":_vm.smallScreen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }